var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 11.622c0-5.346 4.48-9.684 10-9.684s10 4.338 10 9.684c0 5.346-4.48 9.685-10 9.685S2 16.968 2 11.622Zm2 0c0 4.271 3.59 7.748 8 7.748s8-3.477 8-7.748c0-4.27-3.59-7.748-8-7.748s-8 3.477-8 7.748Z",
  fill: "#9F9F9F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.987 13.005C14.76 13.005 16 11.72 16 9.872S14.76 6.78 12.987 6.78H9.583a.255.255 0 0 0-.25.26v4.467H8.25a.255.255 0 0 0-.25.26v.98c0 .143.112.26.25.26h1.083v.691H8.25a.255.255 0 0 0-.25.26v.864c0 .143.112.26.25.26h1.083v1.124c0 .143.112.26.25.26h1.22c.138 0 .25-.117.25-.26V15.08h3.364c.138 0 .25-.117.25-.26v-.865a.255.255 0 0 0-.25-.259h-3.364v-.692h1.934Zm-1.934-4.74h1.64c.974 0 1.56.63 1.56 1.607 0 .991-.586 1.634-1.586 1.634h-1.614v-3.24Z",
  fill: "#9F9F9F"
})));
export default SvgPaid;